import React from 'react';

export function LeftAlignedCellRenderer(props) {
    return <span style={{ justifySelf: 'flex-start' }}>{props.value}</span>;
}

export function BooleanCellRenderer(props) {
    return <span style={{ justifySelf: 'flex-start' }}>{props.value ? "True" : "False"}</span>;
}

export function DateRenderer(props) {
    let date = new Date(props.value);
    // Format date to DD/MM/YYYY
    const dateString = date.toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
    
    // Format time as HH:MM AM/PM
    const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });

    return ( 
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <div style={{ height: 'auto', width: 'auto', lineHeight: 'normal' }}>{dateString}</div>
            <div style={{ height: 'auto', width: 'auto', lineHeight: 'normal' }}>{time}</div>
        </div>
    );
}

export function PriceRenderer(props) {
    if(props.value === "?" || props.value === "N/A" || props.value === "" || props.value === 0){ 
        return <span>{props.value}</span>;
    } else {
        return <span>${props.value}</span>;
    }
}